<template>
	<div class="container">
		<!--  搜索  -->
		<search-bar ref="search"></search-bar>
		<!--  分类  -->
		<sort-selection show-more-btn :list="sortList" @changeParams="changeParams"></sort-selection>

		<div class="g-flex g-row-center g-m-t-30">
			<div class="total-width">
				<!--  轮播  -->
				<el-carousel arrow="never">
					<el-carousel-item v-for="(item,index) in imgList" :key="index">
						<a :href="item.target" target="_blank"><img :src="item.imageUrl" class="swiper-img" alt=""></a>
					</el-carousel-item>
				</el-carousel>
				<!--  列表  -->
				<div class="g-flex g-flex-wrap g-row-between">
					<div class="g-m-t-60" v-for="(item,index) in careerList" :key="index">
						<applicant-card :item="item"></applicant-card>
					</div>
				</div>
				<!--  分页  -->
				<div class="g-flex g-row-center g-m-t-30">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="params.current" :page-sizes="[10, 20, 30, 40]" :page-size="params.size"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
	import SearchBar from "@/components/search-bar";
	import SortSelection from "@/components/sort-selection";
	import ApplicantCard from "@/components/applicant-card";
	import {
		portalList,
		postSelect,
		getTalentList
	} from "@/api/job.js"
	import {
		dictionary
	} from "@/api/api.js"
	import {
		getCarousel
	} from "@/api/home.js"
	export default {
		name: "find-careers",
		components: {
			ApplicantCard,
			SortSelection,
			SearchBar
		},
		data() {
			return {
				careerList:[],
				imgList:[],
				sortList: [{
						pId: 2,
						label: '选择职业',
						sublist: []
					},
					{
						pId: 3,
						label: '工作年限',
						sublist: []
					},
					{
						pId: 4,
						label: '期望薪资',
						sublist: []
					},
					{
						pId: 5,
						label: '学历要求',
						sublist: []
					}
				],
				currentPage: 1,
				size: 10, //当前页
				total: 0,
				params: {
					postName: '',
					current: 1,
					size: 10,
					education: '', //学历
					salary: '', //薪资
					postId: '',
					workYear: '',
					search:''
				}
			}
		},
		watch: {
			'$route'(to, from) {
				console.log(to)
				this.params.search = to.query.s
				this.current = 1
				this.getCareerList()
			}
		},
		mounted() {
			let queryWord = this.$route.query.s;
			if(queryWord&&this.params.search!=queryWord){
				this.params.search = queryWord;
			}
			this.$refs.search.menuIndex = 2;
			this.$refs.search.keyword = queryWord;
			this.getDictionary('diploma')
			this.getDictionary('salary')
			this.getDictionary('work_year')
			this.getPortalList(),
			this.getImgList()
		},
		methods: {
			getCareerList() {
				getTalentList(this.params).then(res=>{
					this.careerList=res.records
				})
			},
			getImgList(){
				getCarousel({
					classification:'talent',
					status:2
				}).then(res=>{
					this.imgList=res.records
				})
			},
			changeParams(e){
				
				console.log(e)
				
				this.params.postId=e[0].subItem.dictKey
				this.params.workYear=e[1].subItem.dictKey
				this.params.salary=e[2].subItem.dictKey
				this.params.education=e[3].subItem.dictKey
				
				this.current=1
				this.getCareerList()
				
			},
			getPortalList(){
				// portalList({}).then(res => {
				// 	console.log('getPortalList',res)
				// 	this.portalList = JSON.parse(JSON.stringify(res).replace(/postName/g, 'dictValue').replace(/id/g,'dictKey'));
				// 	this.sortList[0].sublist=this.portalList
				// })
				postSelect({}).then(res => {
					this.portalList = JSON.parse(JSON.stringify(res).replace(/postName/g, 'dictValue').replace(/id/g,'dictKey'));
					this.sortList[0].sublist=this.portalList
				})
			},
			getDictionary(type){
				dictionary(
					{code:type}
				).then(res => {
					this[type+'_list']=res;
					if(type=='diploma'){
						this.sortList[3].sublist=res
					}
					if(type=='salary'){
						this.sortList[2].sublist=res
					}
					if(type=='work_year'){
						// if(type=='working_seniority'){
						this.sortList[1].sublist=res
					}
				})
			},
			
			
			// 页数切换
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			// 当前页切换
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
		}
	}
</script>

<style lang="scss" scoped>
	.swiper-img {
		width: 100%;
		height: 130px;
	}

	::v-deep .el-carousel__button {
		padding: 0 !important;
		width: 8px;
		height: 8px;
		border-radius: 50%;
	}

	::v-deep .el-carousel__indicator.is-active button {
		width: 20px !important;
		border-radius: 20px;
	}

	::v-deep .el-carousel .el-carousel--horizontal {
		height: 130px;
	}

	::v-deep .el-carousel__container {
		height: 130px;
	}
</style>
